import {
    FaLightbulb,
    FaMobileAlt,
    FaUserCircle
} from 'react-icons/fa';

export default function IntuitiveApp() {
    const features = [
        { name: 'User-Friendly Interface', description: 'Intuitive experience for employers and employees.', icon: FaUserCircle },
        { name: 'Jobsite Management', description: 'Manage all your jobsites and employees from asingle dashboard.', icon: FaMobileAlt },
        { name: 'Worker Management', description: 'Keep track of your workers, their schedules, and attendance with ease.', icon: FaLightbulb },
        { name: 'Real-time Tracking', description: 'Monitor attendance and job progress in real-time.', icon: FaLightbulb },
        { name: 'Seamless Integrations', description: 'Integrates with your favorite payroll and accounting software.', icon: FaLightbulb },
        { name: 'Customizable Reporting', description: 'Generate custom reports to gain insights into your workforce and operations.', icon: FaLightbulb },
    ];

    const accentColor = 'cyan';

    return (
        <div className="bg-gradient-to-b from-gray-900 to-black text-white py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto grid max-w-2xl grid-cols-1 items-start gap-y-16 gap-x-8 sm:gap-y-24 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                    <div className="lg:pt-4">
                        
                        <h2 className="mt-2 text-4xl font-bold tracking-tight text-white sm:text-5xl">
                            Intuitive App
                        </h2>
                        
                        <p className="mt-6 text-lg leading-8 text-gray-300">
                            allowing you to manage all your jobsites and workers efficiently.
                        </p>

                        <dl className="mt-10 grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-2 lg:mt-16">
                            {features.map((feature) => (
                                <div key={feature.name} className="relative pl-16 group">
                                    <dt className="text-base font-semibold leading-7 text-gray-100 group-hover:text-white transition-colors">
                                        <div className={`absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-${accentColor}-500 group-hover:bg-${accentColor}-400 transition-colors`}>
                                            <feature.icon className="h-6 w-6 text-white" aria-hidden="true" />
                                        </div>
                                        {feature.name}
                                    </dt>
                                    <dd className="mt-2 text-sm leading-6 text-gray-400 group-hover:text-gray-300 transition-colors">
                                        {feature.description}
                                    </dd>
                                    <div className={`absolute -inset-x-4 -inset-y-2 left-0 h-full w-0.5 bg-${accentColor}-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300`} aria-hidden="true"></div>
                                </div>
                            ))}
                        </dl>
                    </div>
                    <div className="flex items-center justify-center lg:justify-end lg:pl-8">
                        <img
                            src="/phoneApp.png"
                            alt="TimeStat Mobile App"
                            className={`rounded-xl shadow-2xl shadow-${accentColor}-500/20 hover:shadow-${accentColor}-400/40 transition-all duration-500 ease-out transform hover:scale-105 w-[24rem] max-w-none sm:w-[32rem] md:-ml-4 lg:-ml-0`}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}